import { ScrollableArea } from "@nova/component-scrollable-area"
import { ReactNode } from "react"

export const UserLocationFlyoutLayersPanelMenu = ({ children }: { children: ReactNode }) => (
    <div className="rounded-lg bg-gray-800 border border-white-200 flex flex-col gap-2 py-3 w-[264px]">
        <small className="xs text-gray-400 px-5 py-0.5">Atlas</small>
        <ScrollableArea className="max-h-[300px] px-3">{children}</ScrollableArea>
    </div>
)
